import { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import {
  emptySinglePanelChart,
  emptyDeliveryPerformanceChart,
  emptyFreightSpendTrendChart,
  emptyQuarterlyAveragesChart,
  initialCharts,
} from "../constants";
import { buildBreakdownQuery } from "../formatters";

export function useQbrCharts(filters, canLoadData) {
  const [charts, setCharts] = useState(initialCharts);
  const [isChartsLoading, setIsChartsLoading] = useState(false);

  useEffect(() => {
    if (!canLoadData) {
      setCharts(initialCharts);
      return;
    }

    let cancelled = false;
    const controller = new AbortController();
    const params = buildBreakdownQuery(filters);

    setIsChartsLoading(true);
    setCharts(initialCharts);

    apiClient
      .get(`/api/v1/difotVisualisation/charts?${params.toString()}`, { signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.detail || payload.error || "Failed to load DIFOT charts");
        }
        return response.json();
      })
      .then((data) => {
        if (cancelled) return;
        setCharts({
          difotByPeriod: data.difotByPeriod || emptyDeliveryPerformanceChart,
          monthlyFreightSpend: data.monthlyFreightSpend || emptyFreightSpendTrendChart,
          quarterlyAverages: data.quarterlyAverages || emptyQuarterlyAveragesChart,
          freightSpendByFromState: data.freightSpendByFromState || emptySinglePanelChart,
          freightSpendByToState: data.freightSpendByToState || emptySinglePanelChart,
        });
      })
      .catch((err) => {
        if (err.name === "AbortError" || cancelled) return;
      })
      .finally(() => {
        if (!cancelled) setIsChartsLoading(false);
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [canLoadData, filters]);

  return { charts, isChartsLoading };
}
